import { Stack } from "@chakra-ui/react";

import { PageHeader } from "../../components/shared/PageHeader";
import { PaymentsSchedulePageContent } from "../../components/features/PaymentsSchedulePage";

export function PaymentsSchedulePage() {
  return (
    <Stack spacing={0} minH="100svh">
      <PageHeader title="Внести платёж" />

      <PaymentsSchedulePageContent />
    </Stack>
  );
}
